import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';
import store from "../../../reduxStore/store";
import {filterServiceAgeement} from '../../features/helpers/serviceDetailsHelper';
import { encryptData } from '../../utils/hashing';

const serviceDetails = async (customerNumber, address, isRescheduleApi = false, saNum = null) => {
  var requestBody = null;
  const { post: postClient } = BaseClient();
  if(isRescheduleApi === true) {
    requestBody = mapRequestReschedule(customerNumber, saNum);
    const response = await postClient(process.env.REACT_APP_ECOMM_URL+endpoint.rescheduleDetails(), requestBody, {}, true);
    let responseBody = response.data;
    const retCode = response.statusText;
    const resStatus=response.status;
    if(retCode === 'OK'|| resStatus == 200) {
      return response;
    }

    return mapError(response, "rescheduleDetails");
  }
  else {
    requestBody = mapRequest(customerNumber);

    let addrID = null;
    if(document.getElementById("serviceAddressSelect")){
      addrID = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[2] || "";
      
      if(addrID !== "" && addrID !== null && addrID !== undefined && addrID !== "undefined")
        requestBody.addressID = parseInt(addrID);
    }

    const response =  await postClient(process.env.REACT_APP_ECOMM_URL+endpoint.serviceDetails(), requestBody, {}, true);
    const mapResponseWithAddress =  mapResponse(address);
    return mapResponseWithAddress(response);
  }
};

//map body to request body as per API
const mapRequest = (customerNumber) => {

  const customerInfo = store.getState().login.customerInfo;
  const selAdd = store.getState().accountSummary.selectedServiceAddress;

  let serviceAddress = null;
  let cusNumber = null;
  let addressID = null;

  if(selAdd !== null){
    [serviceAddress, cusNumber] = selAdd.split(" | ");
  }
  
  if(customerInfo && customerInfo.length > 0){
    for(const customer of customerInfo) {
      if(customer.CustomerNumber === customerNumber){
        
        if(serviceAddress === null){
          serviceAddress = customer.ServiceAddresses?.[0]?.address || null;
        }

        if(customer.ServiceAddresses && customer.ServiceAddresses.length > 0){
          for(const srvcAddress of customer.ServiceAddresses) {
            if(srvcAddress.address === serviceAddress){
              addressID = srvcAddress.addressId;
              break;
            }
          }
        }
        if(addressID !== null){
          break;
        }
      }
    }
  }

  customerNumber = process.env.NEXT_PUBLIC_CUSLOC_ENABLE === "true" ? `${customerNumber}__customervalue${Date.now()}` : customerNumber;
  return  {
    CustomerNumber: encryptData(customerNumber, "customerNumber"),
    addressID: addressID
  };
};

//map body to request body as per reschedule API
const mapRequestReschedule = (customerNumber, saNum) => {
  return  { 'cusNum':customerNumber, 'SAN': saNum };
};

const mapResponse = (address) => response => {
  let responseBody = response.data;
  const retCode = response.statusText;
  const resStatus=response.status;
  let salesAgreements= [];
  if(retCode === 'OK'|| resStatus == 200) {
    //filter agreements as per addresss
    if(responseBody.SalesAgreements){
      salesAgreements=responseBody.SalesAgreements.filter(service=>service.svcAddressLine1.includes(address));
    }
    //filter agreements for dispalying
    salesAgreements = salesAgreements.filter(item =>((
      (item.ServiceAgreementType === 'OneTime')))
      ||item.inactiveStatus !== 'INA' );
    responseBody.SalesAgreements = salesAgreements; 
    //filter agreements as per year
    responseBody.InvoiceYears=(responseBody.InvoiceYears).filter( year  =>  filterServiceAgeement(responseBody, year).length>0);
    return responseBody;
  }
  
  return mapError(response, "serviceDetails");
};
//map error to object needed by React view
const mapError = (response, apiName = "") => {
  const { formatError } = BaseClient();
  return formatError(response, `Some Error Occured.`);
};

export default serviceDetails;